import React from 'react';
import cn from 'classnames';
import DocumentationRequirementBulletItem from './../DocumentationRequirementBulletItem';
import SectionTitle from '../../Shared/Tailwind/SectionTitle';

type Item = {
  label: string;
  description: string;
  sampleText?: string;
};

type Section = {
  title: string;
  items: Item[];
};

const styles = {
  card: 'self-stretch p-10 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-brand-cyan inline-flex flex-col justify-start items-start',
  title: 'justify-start text-blue text-3xl font-normal font-serif leading-10',
  introSection: 'self-stretch pt-6',
  introText: 'self-stretch text-left text-gray-800 text-lg font-normal leading-7',
  sectionWrap: 'self-stretch pt-8',
  sectionList: 'self-stretch flex flex-col gap-6',
  sectionCard: 'self-stretch p-6 rounded-lg outline outline-1 outline-offset-[-1px] outline-brand-border',
  sectionHeading: 'text-brand-navy text-xl font-bold leading-8',
  helperText: 'pt-4 text-left text-gray-800 text-base font-normal leading-6',
  bulletList: 'pt-4 flex flex-col gap-3',
};

const sections: Section[] = [
  {
    title: 'Scholarship Requests',
    items: [
      {
        label: 'List of Registered Classes:',
        description: 'Provide either a screenshot or document clearly identifying the number of credits you are enrolled in.',
        sampleText: 'View Sample',
      },
      {
        label: 'Detailed Financial Statement:',
        description:
          'Document that breaks down all charges and payments on your account for a specific term/period. It should show tuition, fees, housing costs, financial aid and other charges.',
        sampleText: 'View Sample',
      },
      {
        label: 'FAFSA:',
        description:
          "To remain eligible for financial aid, you will need to resubmit the Free Application for Federal Student Aid (FAFSA) for every year you're enrolled in school.",
        sampleText: 'View Sample',
      },
      {
        label: 'Grades & GPA:',
        description:
          'Official or unofficial transcript from your school that should include your GPA. Blackboard or Canvas do not typically display overall GPA.',
        sampleText: 'View Sample',
      },
    ],
  },
  {
    title: 'Incentive Payout Requests',
    items: [
      {
        label: '2 Most Recent Pay Stubs:',
        description: 'Pay stubs must be recent and match the employment information provided in your Successful Futures profile.',
        sampleText: 'View Sample',
      },
    ],
  },
];

const SampleDocument = () => {
  return (
    <div className={cn(styles.card)}>
      <SectionTitle className={styles.title}>Documentation Requirements</SectionTitle>
      <div className={cn(styles.introSection)}>
        <div className={cn(styles.introText)}>
          Before you begin, please review the documentation requirements for each type of request. This form can be saved for up to 60 days so allow
          you to gather the necessary information. After 60 days, the form will expire and you will be required to start a new request.
        </div>
      </div>
      <div className={cn(styles.sectionWrap)}>
        <div className={cn(styles.sectionList)}>
          {sections.map((section) => (
            <div key={section.title} className={cn(styles.sectionCard)}>
              <SectionTitle className={styles.sectionHeading}>{section.title}</SectionTitle>
              <div className={cn(styles.helperText)}>Please provide the following documents:</div>
              <div className={cn(styles.bulletList)}>
                {section.items.map((item) => (
                  <DocumentationRequirementBulletItem key={item.label} label={item.label} description={item.description} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SampleDocument;
